const name = 'circle-w';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path fill="#FFF" d="M26.07 55h-6.629l-7.208-28.42h5.717l3.231 12.926 1.74 9.031h.415l1.574-9.031 3.149-12.926h6.131l3.314 12.926 1.575 9.031h.414l1.574-9.031 3.232-12.926h5.468L42.559 55H35.93l-3.48-12.677-1.326-6.546h-.414l-1.243 6.546z"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'W',
};

export default icon;
